import clsx from 'clsx';
import React from 'react';

const Lozenge = ({ children, appearance = 'default', className }) => {
  return (
    <span
      className={clsx(
        `text-xs font-medium py-0.5 px-1 rounded`,
        {
          'text-gray-500 bg-gray-100': appearance === 'default',
          'text-white bg-green-100': appearance === 'success',
          'text-white from-chocolate-500 to-pink-500 bg-gradient-to-r':
            appearance === 'attention',
        },
        className,
      )}
    >
      {children}
    </span>
  );
};

export default Lozenge;
